<template>

    <div class="editworkorder">
        <slot name="editHead">
            <div class="editworkorderHead">
                <div class="backworkorder" style="cursor: pointer">
                    <span @click="backClick"><i class="el-icon-arrow-left"></i></span>
                    <span v-if="$route.query.url==='customerDetail'" @click="backClick">返回</span>
                    <span v-if="$route.query.url==='workOrderInfo'" @click="backClick">返回工单列表</span>
                </div>
                <!--<div class="editFunBtn1">
                        <span class="editShare">分享</span>
                        <span class="newOpenOrder">重新开启工单</span>
                        <span class="reminderBtn">催单</span>
                </div>-->
                <div class="menu-container">
                    <!-- <div class="editFunBtn2">
                    <span class="shareBtn"
                          @click="shareClick"
                          v-clipboard:copy="copyUrl"
                          v-clipboard:success="onCopy"
                    >分享</span>
                    <span class="orderTakingBtn">接单</span>
                    <span class="closeBtn" @click="dialogVisible2=true">关闭</span>
                    <span class="delBtn" @click="dialogVisible1=true">删除</span>
                    <el-dialog
                            title="删除提示"
                            :visible.sync="dialogVisible1"
                            custom-class="editDeleteDialog"
                            >
                        <span>是否删除工单</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible1 = false">取 消</el-button>
                            <el-button type="danger" @click="deleteTemplate">确 定</el-button>
                      </span>
                    </el-dialog>
                    <el-dialog
                            title="关闭提示"
                            :visible.sync="dialogVisible2"
                            custom-class="editDeleteDialog"
                    >
                        <span>是否关闭此工单？</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible2 = false">取 消</el-button>
                            <el-button type="danger" @click="closeWorkOrder">确 定</el-button>
                      </span>
                    </el-dialog>
                    <span class="followBtn" @click="followOrder">关注</span>
                    <span class="reminderBtn" @click="remindWorkOrder">催单</span>
                </div> -->
                <el-button class="first" size="small" @click="shareClick" v-clipboard:copy="copyUrl" v-clipboard:success="onCopy">分享</el-button>
                <el-button size="small" @click="orderTaker">接单</el-button>
                <el-button size="small" @click="closeOrderStatus">关闭</el-button>
                <el-button size="small" @click="dialogVisible1=true">删除</el-button>
                <el-button size="small" @click="followOrder">关注</el-button>
                <el-button class="last" size="small" @click="remindWorkOrder">催单</el-button>
                <!--<el-button class="next-items first" size="small" @click="beforeOrder"><i class="el-icon-arrow-left"></i></el-button>
                <el-button class="last" size="small" @click="afterOrder"><i class="el-icon-arrow-right"></i></el-button>-->
                </div>
                 <el-dialog
                    title="删除提示"
                    :visible.sync="dialogVisible1"
                    custom-class="editDeleteDialog"
                >
                        <span>是否删除工单</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible1 = false">取 消</el-button>
                            <el-button type="danger" @click="deleteTemplate">确 定</el-button>
                      </span>
                    </el-dialog>
                    <el-dialog
                            title="关闭提示"
                            :visible.sync="dialogVisible2"
                            custom-class="editDeleteDialog"
                    >
                        <span>是否关闭此工单？</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible2 = false">取 消</el-button>
                            <el-button type="danger" @click="closeWorkOrder">确 定</el-button>
                      </span>
                    </el-dialog>
            </div>
        </slot>
      <slot name="editContain">
          <div class="editworkorderContain">
              <div class="editOrderTemplate">
                    <el-scrollbar style="height: 100%;">
                        <div style="width: 100%;height:calc(100vh - 85px);">
                    <div class="templateAttrTitle"><span class="demonstration">模板属性</span></div>
                    <div class="templateSplit"></div>

                    <div class="templateAttrCon">
                        <div class="orderTemplateTitle">工单模板</div>
                        <div class="orderTemplateSelct">
                            <el-select v-model="orderTemplate"
                                        clearable
                                        placeholder="请选择"
                                        style="width: 100%;"
                                        @change="getTemplate"

                            >
                                <div>
                                    <el-option
                                            v-for="item in workOrderTemplateList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"


                                    >
                                    </el-option>
                                </div>



                            </el-select>
                        </div>
                    </div>
                    <!-- <div class="defaultCascade" v-for="(item,index) in filedCascadeList" :key="item.fieldId">
                        <div class="defaultCascadeTitle">{{item.field.name}}</div>
                        <div class="defaultCascadeSelect">
                            <el-cascader
                                    v-model="casca[index]"
                                    :options="cascades"
                            ></el-cascader>
                        </div>
                    </div>-->
                            <div v-for="(item,index) in detailOrderDefaultField" :key="item.fieldId">
                                <div class="defaultSingleField" v-if="item.field.type==='INPUT'">
                                    <div class="defaultFieldTitle"><span v-if="item.required===true" style="color: red">*</span>{{item.field.name}}</div>
                                    <div class="defaultFieldSinge">
                                        <el-input
                                                placeholder="请输入内容"
                                                v-model="singeText[index]"
                                                clearable
                                                @blur="modifyWorkOrder"
                                        >
                                        </el-input>

                                    </div>
                                </div>
                                <div class="defaultMultiline" v-if="item.field.type==='TEXTAREA'">
                                  <div class="defaultMultilineTitle"><span v-if="item.required===true" style="color: red">*</span>{{item.field.name}}</div>
                                    <div class="defaultMultilineInput">
                                        <el-input
                                                type="textarea"
                                                :rows="2"
                                                placeholder="请输入内容"
                                                v-model="textarea[index]"
                                                @blur="modifyWorkOrder"
                                        >
                                        </el-input>
                                    </div>
                                </div>
                                <div class="defaultSelectFiled" v-if="item.field.type==='SELECT'">
                                    <div class="SelectFiledTitle"><span v-if="item.required===true" style="color: red">*</span>{{item.field.name}}</div>
                                    <div class="SelectFiledSelect">
                                        <el-select
                                                v-model="selectFiled[index]"
                                                clearable
                                                placeholder="请选择"
                                                style="width: 100%;"
                                                @change="modifyWorkOrder"
                                        >
                                            <el-option
                                                    v-for="item in item.field.extInfo.exinfo"
                                                    :key="item.value"
                                                    :label="item.value"
                                                    :value="item.value"


                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="defaultCascade" v-if="item.field.type==='CASCADER'">

                                    <div class="defaultCascadeTitle"><span v-if="item.required===true" style="color: red">*</span>{{item.field.name}}</div>
                                    <div>
                                        <el-cascader
                                                clearable
                                                v-model="cascade2Option1[index]"
                                                :options="item.field.extInfo.cascadeDown[0].options"
                                                @change="modifyWorkOrder"
                                                style="width: 100%"
                                        >
                                        </el-cascader>
                                    </div>
                                </div>

                                <div class="defaultRadio" v-if="item.field.type==='RADIO'">
                                    <div class="defaultRadioTitle"><span v-if="item.required===true" style="color: red">*</span>{{item.field.name}}</div>
                                    <div class="defaultRadioCheck" style="padding-top:4px;">
                                        <el-radio-group v-model="editRadio[index]">
                                            <el-radio
                                                    v-for="(items,index) in item.field.extInfo.exinfo"
                                                    :label="items.value"
                                                    :key="index"
                                                    :value="items.value"
                                                    style="min-width:72px;line-height: 2"
                                                    @change="modifyWorkOrder"
                                            ></el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="defaultCheckBox" v-if="item.field.type==='CHECKBOX'">
                                    <div class="editCheckTitle"><span v-if="item.required===true" style="color: red">*</span>{{item.field.name}}</div>
                                    <div style="padding-top:4px;line-height: 2">
                                        <el-checkbox-group v-model="editCheck[[index]]" @change="modifyWorkOrder">
                                            <el-checkbox
                                                    v-for="items in item.field.extInfo.exinfo"
                                                    :key="items.value"
                                                    :label="items.value"
                                                    style="min-width:72px !important;line-height: 2"
                                            >{{items.value}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>

                                </div>

                                <div class="defaultDate" v-if="item.field.type==='DATE_PICKER'">
                                    <div class="defaultDateTitle"><span v-if="item.required===true" style="color: red">*</span>{{item.field.name}}</div>
                                    <el-date-picker
                                            v-model="editDate[index]"
                                            type="date"
                                            placeholder="选择日期"
                                            style="width: 100%"
                                            @change="modifyWorkOrder"
                                    >
                                    </el-date-picker>
                                </div>
                                <div class="defaultTime" v-if="item.field.type==='TIME_PICKER'">
                                    <div class="defaultTimeTitle"><span v-if="item.required===true" style="color: red">*</span>{{item.field.name}}</div>
                                    <el-time-picker
                                            arrow-control
                                            v-model="editTime[index]"
                                            placeholder="任意时间点"
                                            style="width: 100%"
                                            @change="modifyWorkOrder"
                                    >
                                    </el-time-picker>
                                </div>
                            </div>



                                  </div>
                              </el-scrollbar>
                          </div>
              <div class="processingRecords">
                  <div class="top"  v-show="lookWorkOrder===0">
                      <el-scrollbar style="height: 100%;">
                          <div style="width: 98%;height:120px">
                              <div class="editThemeShow">
                                  <div class="editTheme">
                                      <div class="editThemeName">
                                          <div class="editThemeNameText">
                                              <span>主题:</span>
                                              <span>{{themeName}}</span>
                                          </div>
                                          <div class="editThemeNameRivese" @click="modifyTheme">
                                              <i class="el-icon-edit"></i>
                                          </div>
                                      </div>
                                      <div :class="showTotal ? 'total-introduce' : 'detailed-introduce'">
                                          <div class="intro-content"  ref="desc" >
                                                <span class="merchant-desc" v-if="themeDescribe" v-html="themeDescribe">
                                                  {{themeDescribe}}
                                                </span>

                                          </div>
                                      </div>
                                      <div
                                              v-if="showPreview"
                                              style="
                                                        width: 100vw;
                                                        height: 100vh;
                                                        z-index: 10000;
                                                        position: fixed;
                                                        top: 0;
                                                        left: 0;
                                                        background-color: rgba(0, 0, 0, 0.8);
                                                      ">
                                          <div
                                                  @click="showPreview = false"
                                                  style="
                                                          color: white;
                                                          font-size: 30px;
                                                          padding: 30px 30px 15vh;
                                                          text-align: right;
                                                          cursor: pointer;
                                                        "
                                          >
                                              X
                                          </div>
                                          <img
                                                  style="max-height: 70vh; max-width: 70vw;margin: auto;display: block;"
                                                  :src="previewImageUrl"
                                                  alt
                                                  srcset
                                          />
                                      </div>

                                      <el-divider></el-divider>
                                      <div @click="showTotalIntro" v-if="showExchangeButton">
                                          <div style="text-align: center;background-color: white;cursor: pointer">
                                              <i class="el-icon-caret-bottom" v-if="exchangeButton===true"></i>
                                              <i class="el-icon-caret-top" v-if="exchangeButton===false"></i>
                                          <!--    <img src="../../../assets/images/workorder/editworkorder/down.png">-->
                                              <span>{{exchangeButton ? '展开' : '收起'}}</span>
                                          </div>
                                      </div>

                                  </div>
                              </div>

                                  <div v-for="(item,index) in templateDetail.workOrderChangeLogs" :key="index">
                                  <div class="modifyAttrInfo"  v-if="(item.changeType==='ATTRIBUTE'||item.changeType==='FIELD'||item.changeType==='REMIND')">
                                      <modify-work-order-attr
                                              :modifyLogInfo="item"
                                              :key="item.id"
                                      />
                                  </div>
                                  <div class="internalRemarksInfo" v-if="(item.changeType!=='ATTRIBUTE'&&item.changeType!=='FIELD'&&item.changeType!=='REMIND')">
                                      <InternalRemarks
                                              :key="index"
                                              :replayInfo="item"
                                      />
                                  </div>
                              </div>



                          </div>
                      </el-scrollbar>
                  </div>
                  <div class="editRichText" v-show="lookWorkOrder===0">
                      <el-button type="primary" round style="width: 100%"  @click="lookWorkOrderClick">回复工单</el-button>
                  </div>
                  <div class="top2"  v-show="lookWorkOrder===1">
                      <el-scrollbar style="height: 100%;">
                          <div style="width: 98%;height:120px">
                              <div class="editThemeShow">
                                  <div class="editTheme">
                                      <div class="editThemeName">
                                          <div class="editThemeNameText">
                                              <span>主题:</span>
                                              <span>{{themeName}}</span>
                                          </div>
                                          <div class="editThemeNameRivese" @click="modifyTheme">
                                              <i class="el-icon-edit"></i>
                                          </div>
                                      </div>
                                      <div :class="showTotal ? 'total-introduce' : 'detailed-introduce'">
                                          <div class="intro-content"  ref="desc">
                                                <span class="merchant-desc" v-if="themeDescribe" v-html="themeDescribe">
                                                  {{themeDescribe}}
                                                </span>

                                          </div>
                                      </div>
                                      <div
                                              v-if="showPreview"
                                              style="
                                                        width: 100vw;
                                                        height: 100vh;
                                                        z-index: 10000;
                                                        position: fixed;
                                                        top: 0;
                                                        left: 0;
                                                        background-color: rgba(0, 0, 0, 0.8);
                                                      "
                                      >
                                          <div
                                                  @click="showPreview = false"
                                                  style="
                                                          color: white;
                                                          font-size: 30px;
                                                          padding: 30px 30px 15vh;
                                                          text-align: right;
                                                          cursor: pointer;
                                                        "
                                                                                          >
                                              X
                                          </div>
                                          <img
                                                  style="max-height: 70vh; max-width: 70vw;margin: auto;display: block;"
                                                  :src="previewImageUrl"
                                                  alt
                                                  srcset
                                          />
                                      </div>

                                      <el-divider></el-divider>
                                      <div @click="showTotalIntro" v-if="showExchangeButton">
                                          <div style="text-align: center;background-color: white;cursor: pointer">
                                              <i class="el-icon-caret-bottom" v-if="exchangeButton===true"></i>
                                              <i class="el-icon-caret-top" v-if="exchangeButton===false" ></i>
                                              <span>{{exchangeButton ? '展开' : '收起'}}</span>
                                          </div>
                                      </div>

                                  </div>
                              </div>
                              <div v-for="(item,index) in templateDetail.workOrderChangeLogs" :key="index">
                                  <div class="modifyAttrInfo"  v-if="(item.changeType==='ATTRIBUTE'||item.changeType==='FIELD'||item.changeType==='REMIND')">
                                      <modify-work-order-attr
                                              :modifyLogInfo="item"
                                              :key="item.id"
                                      />
                                  </div>
                                  <div class="internalRemarksInfo" v-if="(item.changeType!=='ATTRIBUTE'&&item.changeType!=='FIELD'&&item.changeType!=='REMIND')">
                                      <InternalRemarks
                                              :key="index"
                                              :replayInfo="item"
                                      />
                                  </div>
                              </div>


                          </div>
                      </el-scrollbar>
                  </div>
                  <div class="editRichText2" v-show="lookWorkOrder===1">
                       <div >
                           <div class="editorRemark">
                               <div class="editorRemarkLeft">
                                   <div :class="{isBlue:isBlue===1}"  class="topBar" style="border-top-left-radius: 5px">内部备注</div>
                                  <!-- <div :class="{isBlue:isBlue===0}" @click="emailResClick" class="topBar">邮件回复</div>
                                   <div v-show="isBlue===0" class="emailUserInfo">
                                       <span style="margin-right: 10px" ref="userName">{{editCustomerName}}</span>
                                       <span v-if="(clientDetailInfo.mail===undefined&&editEamil===1)||(clientDetailInfo.mail===''&&editEamil===1)">(暂无邮箱地址)</span>
                                       <span style="margin-right: 10px"  v-if="clientDetailInfo.mail!==''&&editEamil===1">{{clientDetailInfo.mail}}</span>
                                       <span v-if="editEamil===0">
                                           <el-input
                                                   placeholder="请输入内容"
                                                   v-model="inputEamil"
                                                   clearable
                                                   @blur="inputEamilFinish"
                                                   size="mini"
                                                   style="width: 70%;"
                                           >
                                            </el-input>
                                       </span>
                                       <span v-if="editEamil===1">
                                           <img src="../../../assets/images/fieldmanage/rivese.png" style="height: 16px;width: 16px;cursor: pointer" @click="riveseClick">
                                       </span>
                                   </div>-->
                               </div>
                               <span  @click="backReplyWorkOrder" style="color: #409EFF;text-align: right;margin-right: 5px;cursor: pointer" class="packUp">收起</span>
                           </div>
                           <div class="replayUeditor" >
                               <vue-ueditor-wrap v-model="ueditor" :config="myConfig" id="editor" @focus="ueditorFocus" @ready="ready"/>
                           </div>

                            <div class="submit"><el-button  type="primary" size="small" @click="postReply" :disabled="disableds">提交</el-button></div>
                       </div>

                  </div>
              </div>
              <div class="editOrderAttr">
                      <el-scrollbar style="height: 100%">
                          <div style="width: 100%;height: calc(100vh - 85px)">
                              <div class="orderAttrText"><span>工单属性</span></div>
                              <div class="templateSplit"></div>
                              <div class="editOrderStatus">
                                  <div class="editStatusTitle">状态:</div>
                                  <div class="editStatusBtn" @mouseout="outClick" v-if="showaaaa===1&&nextStatusList.length!==0">
                                    <el-select v-model="addstatusSelect"
                                               placeholder="请选择"
                                               style="width: 100%"
                                               @focus="getNextStatus"
                                               @change="modifyWorkOrder"
                                               @visible-change="visibleChange"

                                    >
                                      <div style="line-height: 40px;">
                                        <el-option
                                            v-for="(item,index) in nextStatusList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                      </div>


                                    </el-select>
                                  </div>
                                  <div class="editStatusBtn1" v-if="showaaaa===0&&nextStatusList.length!==0" @mouseover="mouseOrderStatus1">
                                    <div class="editStatusBtn1">{{showaddstatusSelect}}</div>
                                  </div>
                                <div v-if="nextStatusList.length === 0">--</div>

                              </div>
                              <div class="editPriority">
                                  <div class="editPriorityText">优先级:</div>
                                  <div class="editPrioritySelect" @mouseout="outClick" v-if="showPriority===1&&addprioritySelect!==''">
                                    <el-select
                                        v-model="addprioritySelect"
                                        placeholder="请选择"
                                        style="width: 100%"
                                        @change="modifyWorkOrder"
                                        @visible-change="visibleChange2"
                                    >
                                      <div style="line-height: 40px;">
                                        <el-option
                                            v-for="(item,index) in prioritySelect"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                      </div>

                                    </el-select>
                                  </div>
                                  <div class="editPrioritySelect"  @mouseover="mouseOrderStatus2" v-if="showPriority===0&&addprioritySelect!==''">
                                    <div class="editPrioritySelect">{{showaddprioritySelect}}</div>
                                  </div>

                                <div v-if="addprioritySelect===''">
                                  --
                                </div>
                              </div>
                              <div class="editCustomer">
                                  <div class="editCustomerText">客户:</div>
                                  <div  class="editCustomerSelect" @mouseover="mouseOrderStatus3" v-if="showClient===0">
                                      <div v-if="editCustomer===''" class="editCustomerSelect">--</div>
                                      <div v-if="editCustomer!==''" class="editCustomerSelect">{{editCustomerName}}</div>
                                  </div>
                                  <div class="editCustomerSelect" v-if="showClient===1" @mouseout="outClick">
                                      <el-select v-model="editCustomer"
                                                 placeholder="请选择"
                                                 style="width: 100%;position: relative"
                                                 @change="modifyWorkOrder"
                                                 ref="hideSelect"
                                                 v-loadmore="loadMoreClient"
                                                 @visible-change="visibleChange3"


                                      >
                                          <div style="margin: 5px 0">
                                              <el-input
                                                      v-model="customerInput"
                                                      placeholder="可搜索"
                                                      style="position: absolute;top: 0;z-index: 9"
                                                      @input="changeSelectClient"
                                              >
                                                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                              </el-input>
                                          </div>
                                          <div v-if="selectClientList.length===0">
                                              <el-option value="113" style="height: 40px"></el-option>
                                          </div>
                                          <div style="margin-bottom: 40px;margin-top: 36px">
                                              <el-option
                                                      v-for="item in selectClientList"
                                                      :key="item.id"
                                                      :label="item.name"
                                                      :value="item.id">
                                              </el-option>
                                          </div>

                                          <div style="position: absolute;width: 100%;bottom: 0">
                                              <el-button type="primary" style="width: 100%" @click="addClientBtn">新增客户</el-button>
                                          </div>
                                      </el-select>
                                  </div>
                              </div>
                              <div class="editAccpGroup">
                                  <div class="editAccpGroupText">受理组:</div>
                                  <div class="editAccpGroupSelect" @mouseout="outClick" v-if="showGroup===1">
                                      <el-select
                                              v-model="editaccpgroup"
                                              placeholder="请选择"
                                              style="width: 100%;position: relative"
                                              @change="groupClick"
                                              @visible-change="visibleChange4"
                                      >
                                          <div style="margin: 5px 0;">
                                              <el-input
                                                      v-model="accpgroupInput"
                                                      placeholder="可搜索"
                                                      @input="changeSelectOrderGroup"
                                                      style="position: absolute;z-index: 999;top: 0"
                                              >
                                                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                              </el-input>
                                          </div>
                                          <div v-if="selectGroupList.length===0">
                                             <el-option style="height: 5px" value="112"></el-option>
                                          </div>
                                          <div style="line-height: 40px;margin-top: 36px">
                                              <el-option
                                                      v-for="item in selectGroupList"
                                                      :key="item.id"
                                                      :label="item.name"
                                                      :value="item.id">
                                              </el-option>
                                          </div>

                                      </el-select>
                                  </div>
                                  <div class="editAccpGroupSelect" v-if="showGroup===0" @mouseover="mouseOrderStatus4">
                                      <div v-if="editaccpgroup!==''" class="editAccpGroupSelect">{{showeditaccpgroup}}</div>
                                      <div v-if="editaccpgroup===''" class="editAccpGroupSelect">--</div>
                                  </div>
                              </div>
                              <div class="editAccpPerson">
                                  <div class="editAccpPersonText">受理人:</div>
                                  <div class="editAccpPersonSelcet" @mouseout="outClick" v-if="showPerson===1">
                                      <el-select
                                              v-model="editaccpperson"
                                              placeholder="请选择"
                                              style="width: 100%;
                                              position: relative"
                                              @change="modifyWorkOrder"
                                              @visible-change="visibleChange5"
                                      >
                                          <div>
                                              <el-input
                                                      v-model="accppersonInput"
                                                        placeholder="可搜索"
                                                      @input="changeSelectOrderPerson"
                                                      style="position: absolute;top: 0;z-index: 999"
                                              >
                                                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                              </el-input></div>
                                          <div v-if="selectOrderPersonList.length===0">
                                              <el-option style="height: 5px" value="115"></el-option>
                                          </div>
                                          <div style="line-height: 40px;margin-top: 36px">
                                              <el-option
                                                      v-for="item in selectOrderPersonList"
                                                      :key="item.id"
                                                      :label="item.name"
                                                      :value="item.id">
                                              </el-option>
                                          </div>
                                      </el-select>
                                  </div>
                                  <div class="editAccpPersonSelcet" v-if="showPerson===0"  @mouseover="mouseOrderStatus5">
                                      <div v-if="editaccpperson!==''" class="editAccpPersonSelcet">{{orderPersonName}}</div>
                                      <div v-if="editaccpperson===''" class="editAccpPersonSelcet">--</div>
                                  </div>
                              </div>
                              <div class="editResponsePerson">
                                  <div class="editResponsePersonText">关注人:</div>
                                  <div class="editResponsePersonSelcet" @mouseout="outClick" v-if="showFocusPerson===1">
                                      <el-select
                                              v-model="responsePerson"
                                              multiple
                                              placeholder="请选择"
                                              style="width: 100%;cursor: pointer;
                                              position: relative"
                                              @change="modifyWorkOrder"
                                              @visible-change="visibleChange6"
                                      >
                                          <div style="margin: 5px 0">
                                              <el-input
                                                      v-model="responsePersonInput"
                                                      placeholder="可搜索"
                                                      @input="changeFocusPerson"
                                                      style="position: absolute;top: 0;z-index: 999"
                                              >
                                                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                              </el-input>
                                          </div>
                                          <div v-if="selectFocusPersonList.length===0">
                                              <el-option style="height: 5px" value="114"></el-option>
                                          </div>
                                          <div style="line-height: 40px;margin-top: 36px">
                                              <el-option
                                                      v-for="item in selectFocusPersonList"
                                                      :key="item.id"
                                                      :label="item.name"
                                                      :value="item.id">
                                              </el-option>
                                          </div>

                                      </el-select>
                                  </div>
                                  <div class="editResponsePersonSelcet" @mouseover="mouseOrderStatus6" v-if="showFocusPerson===0" >
                                      <div v-if="orderFocusPersonName!==''" class="editResponsePersonSelcet">{{orderFocusPersonName}}</div>
                                      <div v-if="orderFocusPersonName===''" class="editResponsePersonSelcet">--</div>
                                  </div>
                              </div>
                              <div class="editCanal">
                                  <div class="editCanalText">渠道:</div>
                                  <div class="editCanalFrom">{{templateDetail.source|clientSourcetype}}</div>
                              </div>
                              <div class="editCreatePerson">
                                  <div class="editCreatePersonText">创建人:</div>
                                  <div class="editCreatePersonName" v-if="templateDetail.creator!==null">{{creatorName}}</div>
                                  <div class="editCreatePersonName" v-if="templateDetail.creator===null">--</div>
                              </div>
                              <div class="orderCreateTime">
                                  <div class="orderCreateTimeText">创建时间:</div>
                                  <div class="orderCreateTimeContain">{{dateFormat(templateDetail.createTime)}}</div>
                              </div>
                              <div class="orderUpdateTime">
                                  <div class="orderUpdateTimeText">更新时间:</div>
                                  <div class="orderUpdateTimeContain" v-if="dateFormat(templateDetail.updateTime)!==dateFormat(templateDetail.createTime)">{{dateFormat(templateDetail.updateTime)}}</div>
                                <div class="orderUpdateTimeContain" v-else>--</div>
                              </div>
                              <div class="order-customer-split"></div>
                             <div class="editCustomerDetail">
                                 <div class="editCustomerDetailText"><span>客户详情</span></div>
                                 <div class="templateSplit"></div>
                             </div>
                              <div class="customerDetailName">
                                  <div class="detailNameText">姓名:</div>
                                  <div class="detailNameSelect">
                                      <span v-if="editCustomerName!==''">  {{editCustomerName}}</span>
                                      <span v-if="editCustomerName===''">--</span>

                                  </div>
                                  <!--<div v-if="mouseOverNameNum===1" class="detailNameSelect" @mouseout="outName" style="cursor: pointer">
                                      <el-input v-model="inputName" @blur="blurName" style="width: 100%;"></el-input>
                                  </div>-->
                              </div>
                              <div class="customerDetailLevel">
                                  <div class="editDetailLevel">等级:</div>
                                  <!--<div class="editCustomerLevel" v-if="gradeType===1">
                                      <el-select
                                              v-model="clientGradeModel"
                                              @change="changeGrade"
                                              v-on:blur="aaa"
                                      >
                                          <div style="margin-bottom: 12px;line-height: 40px;">
                                              <el-option value="VIP" label="VIP">VIP</el-option>
                                              <el-option value="NORMAL" label="NORMAL">普通</el-option>
                                          </div>

                                      </el-select>
                                  </div>-->
                                  <div class="editCustomerLevel" >
                                      <span  v-if="clientGrade===''">--</span>
                                      <span v-if="clientGrade!==''">{{clientGrade}}</span>
                                  </div>
                              </div>
                              <div class="customerDetailPhone" >
                                  <div class="editDetailPhone">电话:</div>
                                  <div class="editDetailPhoneNum">
                                      <span v-if="clientDetailInfo.tel!==''">{{clientDetailInfo.tel}}</span>
                                      <span v-if="clientDetailInfo.tel===''||Object.keys(this.clientDetailInfo).length===0">--</span>
                                  </div>
                                  <!--<div v-if="mouseTel===1" class="editDetailPhoneNum" @mouseout="outTel" style="cursor: pointer">
                                      <el-input v-model="inputTel" @blur="blurTel"></el-input>
                                  </div>-->
                              </div>
                              <div class="customerDetailEmail" >
                                  <div class="editDetailEmail">邮箱:</div>
                                  <div class="editDetailEmailNum">
                                      <span  v-if="clientDetailInfo.mail!==''"> {{clientDetailInfo.mail}}</span>
                                      <span v-if="clientDetailInfo.mail===''||Object.keys(this.clientDetailInfo).length===0">--</span>

                                  </div>
                                 <!-- <div v-if="mouseMail===1" class="editDetailEmailNum" @mouseout="outMail" style="cursor: pointer">
                                      <el-input v-model="inputMail" @blur="blurEamil"></el-input>
                                  </div>-->

                              </div>

                              <div class="customerDetailCompany" >
                                  <div class="editDetailCompany">公司:</div>
                                  <div class="editDetailCompanyName">
                                      <span v-if="clientCompanyName!==''"> {{clientCompanyName}}</span>
                                      <span  v-if="clientCompanyName===''">--</span>
                                  </div>
                                 <!-- <div v-if="mouseCompany===1" class="editDetailCompanyName" >
                                      <el-select v-model="ClientCompanyValue"
                                                 clearable
                                                 placeholder="请选择或者搜索公司名称"
                                                 style="width: 100%;position: relative"
                                                 v-loadmore="loadMore"
                                                 @change="outCompany"
                                      >
                                          <div style="margin: 5px 0">
                                              <el-input
                                                      placeholder="可搜索"
                                                      v-model="inputSelect"
                                                      clearable
                                                      style="position: absolute;top: 0;z-index: 9"
                                                      @input="changeSelectCompany"
                                              >
                                              </el-input>
                                          </div>
                                          <div v-if="selectCompanyList.length===0">
                                              <el-option value="" style="height: 40px"></el-option>
                                          </div>
                                          <div style="margin-bottom: 40px;margin-top: 32px">
                                              <el-option
                                                      v-for="item in selectCompanyList"
                                                      :key="item.id"
                                                      :label="item.name"
                                                      :value="item.id"
                                              >
                                              </el-option>

                                          </div>

                                          <div
                                                  style="background-color: #409EFF;text-align: center;height: 32px;line-height: 32px;width:100%;cursor: pointer;position: absolute;bottom: 0"
                                                  @click="dialogFormVisible1=true"
                                                  :class="{isNullOption:selectCompanyList.length===0}"
                                          >
                                              <span style="color: white;">新建公司</span>
                                          </div>
                                      </el-select>
                                  </div>-->
                              </div>

                              <div class="customerResponseGroup">
                                  <div class="detailGroupText">负责组:</div>
                                 <!-- <div class="detailGroupSelect" v-if="mouseGroup===1">
                                      <el-select v-model="editClientGroup" placeholder="请选择" style="width: 100%" @change="getClientPerson">
                                          <div><el-input v-model="customerInput" placeholder="可搜索"></el-input></div>
                                          <div style="margin-bottom: 12px;line-height: 40px;">
                                              <el-option
                                                      v-for="item in acountGroupList"
                                                      :key="item.id"
                                                      :label="item.name"
                                                      :value="item.id">
                                              </el-option>
                                          </div>

                                      </el-select>
                                  </div>-->
                                  <div class="detailGroupSelect">
                                      <span v-if="editClientGroup!==''">{{groupName}}</span>
                                      <span v-if="editClientGroup===''">--</span>
                                  </div>
                              </div>
                              <div class="customerResponsePerson">
                                  <div class="detailPersonText">负责人:</div>
                                  <!--<div class="detailPersonSelect" v-if="mousePerson===1">
                                      <el-select v-model="editClientPerson" placeholder="请选择" style="width: 100%" @change="changePerson">
                                          <div><el-input v-model="customerInput" placeholder="可搜索"></el-input></div>
                                        <div style="line-height: 40px;margin-bottom: 12px">
                                            <el-option
                                                v-for="item in clientAccountPersonList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option></div>

                                      </el-select>
                                  </div>-->
                                  <div  class="detailPersonSelect">
                                      <span v-if="editClientPerson!==''">{{editClientPersonName}}</span>
                                      <span v-if="editClientPerson===''">--</span>
                                  </div>
                              </div>
                              <div class="customerDetailRemark">
                                  <div class="editDetailRemarkText">描述:</div>
                                  <div class="editDetailRemarkCon">
                                      <el-input
                                              type="textarea"
                                              :rows="2"
                                              placeholder="请输入内容"
                                              v-model="clientDescription"
                                              style="width: 100%"
                                              @blur="modifyClientDesc"
                                      >
                                      </el-input>
                                  </div>
                              </div>
                              <div class="customer-source-split"></div>
                              <div class="referrer">
                                  <div class="referrerText">访问来源:</div>
                                  <div class="referrerCon">{{clientDetailInfo.clientSource|clientSourcetype}}</div>
                              </div>
                              <div class="apply">
                                  <div class="applyText">应用名称:</div>
                                  <div class="applyName">企业微信</div>
                              </div>
                          </div>
                      </el-scrollbar>


                  </div>
          </div>
      </slot>
        <el-dialog title="编辑工单主题" :visible.sync="dialogFormVisible2" custom-class="customerListDialog" style="text-align: left;z-index: 2000!important;" :modal-append-to-body="false" :close-on-click-modal="false">
            <div class="customerNameCon">
                <div class="customersNameText"><span class="keyred">*</span>工单主题</div>
                <div class="customersNameInput">
                    <el-input
                            placeholder="请输入要修改的工单主题"
                            v-model="editThemeName"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div>
                <div><span style="color: red">*</span>描述</div>
                <div>
                    <vue-ueditor-wrap v-model="editThemeDescribe" :config="myConfig1"></vue-ueditor-wrap>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="modifyThemeFinish">修改</el-button>
            </div>
        </el-dialog>
        <el-dialog title="新增客户" :visible.sync="dialogFormVisible" custom-class="customerListDialog" style="text-align: left" :close-on-click-modal="false">
            <div class="flexClass">
                <div class="flexClass1"><span class="keyred">*</span>客户名称</div>
                <div class="flexClass2">
                    <el-input
                            placeholder="请输入客户名称"
                            v-model="clientName"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">
                    等级
                </div>
                <div class="flexClass2">
                    <el-radio v-model="levelRadio" label="1">普通</el-radio>
                    <el-radio v-model="levelRadio" label="2">vip</el-radio>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">电话</div>
                <div class="flexClass2" >
                    <el-input
                            placeholder="请输入电话"
                            v-model="clientTel"
                            clearable
                            @blur="clientPhoneCheck"
                    >
                    </el-input>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">邮箱</div>
                <div class="flexClass2" >
                    <el-input
                            placeholder="请输入邮箱"
                            v-model="clientMail"
                            clearable
                            @blur="clientEmailCheck"
                    >
                    </el-input>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">公司</div>
                <div class="flexClass2">
                    <el-select v-model="companyValue"
                               clearable
                               placeholder="请选择或者搜索公司名称"
                               style="width: 100%;position: relative"
                               @change="getClientCompany"
                    >
                        <div style="position: absolute;top: 0;z-index: 999;width: 100%">
                            <el-input
                                    placeholder="可搜索"
                                    clearable
                                    v-model="selectCompany"
                                    @input="inputSelectCompany"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="selectCompanyList.length===0">
                            <el-option value="" style="height: 36px"></el-option>
                        </div>
                        <div style="margin-bottom: 40px;margin-top: 36px">
                            <el-option
                                    v-for="item in selectCompanyList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </div>

                        <div style="background-color: #409EFF;text-align: center;cursor: pointer;position: absolute;bottom: 0;width: 100%;height: 32px" @click="createCompany">
                            <span style="line-height: 32px">新建公司</span>
                        </div>
                    </el-select>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">负责组</div>
                <div class="flexClass2" >
                    <el-select v-model="groupValue"
                               clearable
                               placeholder="请选择或者搜索负责组"
                               style="width: 100%;position: relative"
                               @change="getClientAccountPerson"
                    >
                        <div>
                            <el-input
                                    placeholder="可搜索"
                                    clearable
                                    v-model="selectClientGroup"
                                    @input="inputSelectClientGroup"
                                    style="position: absolute;z-index: 999;top: 0"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="selectClientGroupList.length===0">
                            <el-option value="" style="height: 36px"></el-option>
                        </div>
                        <div style="margin-top: 36px;margin-bottom: 10px">
                            <el-option
                                    v-for="item in selectClientGroupList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"

                            >
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">负责人</div>
                <div class="flexClass2" >
                    <el-select v-model="personValue"
                               clearable
                               placeholder="请选择或者搜索负责人"
                               style="width: 100%;position: relative"
                    >
                        <div>
                            <el-input
                                    placeholder="可搜索"
                                    clearable
                                    v-model="selectClientPerson"
                                    style="position: absolute;z-index: 999;top: 0"
                                    @input="inputSelectClientPerson"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="selectClientPersonList.length===0">
                            <el-option value="" style="height: 36px"></el-option>
                        </div>
                        <div style="margin-top: 36px;margin-bottom: 10px">
                            <el-option
                                    v-for="item in selectClientPersonList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div class="flexClass">
                <div class="flexClass1">描述</div>
                <div class="flexClass2">
                    <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="对该客户的描述"
                            v-model="describe">
                    </el-input>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addClient">保存</el-button>
                <el-button type="primary" @click="addClientContinue">保存并继续添加</el-button>
            </div>
        </el-dialog>
        <el-dialog title="新建公司" :visible.sync="dialogFormVisible1" custom-class="customerListDialog" style="text-align: left" :close-on-click-modal="false">
            <div class="companyFlexClass">
                <div class="companyFlexClass1"><span class="keyred">*</span>公司名称</div>
                <div class="companyFlexClass2">
                    <el-input
                            placeholder="请输入公司名称"
                            v-model="companyName"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">
                    等级
                </div>
                <div class="companyFlexClass2">
                    <el-radio v-model="CompanyLevelRadio" label="1">普通</el-radio>
                    <el-radio v-model="CompanyLevelRadio" label="2">vip</el-radio>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">公司邮箱后缀
                    <el-popover
                            placement="top-start"
                            width="230"
                            trigger="hover"
                    >
                        <span style="color: #F56C6C">客户主邮箱的后缀是企业邮箱后缀时，将被自动添加到该公司</span>

                        <span slot="reference" style="margin-left: 4px;">
                                      <i class="el-icon-warning-outline" style="font-size: 14px;color: #AAAAAA"></i>
                                    </span>
                    </el-popover>
                </div>
                <div class="companyFlexClass2">
                    <el-input
                            placeholder="请输入公司邮箱后缀"
                            v-model="emailSuffix"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">公司联系人</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入公司联系人姓名"
                            v-model="contactPerson"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">联系人电话</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入公司联系人电话"
                            v-model="contactPersonTel"
                            clearable
                            @blur="emaiBblurClick"
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">联系人邮箱</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入联系人邮箱"
                            v-model="contactPersonMail"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">负责组</div>
                <div class="companyFlexClass2" >
                    <el-select v-model="companyGroupValue"
                               clearable
                               placeholder="请选择或者搜索负责组"
                               style="width: 100%;position: relative"
                               @change="getCompanyAccountPerson"
                    >
                        <div>
                            <el-input
                                    placeholder="可搜索"
                                    clearable
                                    v-model="selectCompanyGroup"
                                    style="position: absolute;z-index: 999;top: 0"
                                    @input="inputSelectCompanyGroup"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="selectCompanyGroupList.length===0">
                            <el-option value="" style="height: 36px"></el-option>
                        </div>
                        <div style="margin-top: 36px;margin-bottom: 10px">
                            <el-option
                                    v-for="item in selectCompanyGroupList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            >
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">负责人</div>
                <div class="companyFlexClass2" >
                    <el-select v-model="companyPersonValue"
                               clearable
                               placeholder="请选择或者搜索负责人"
                               style="width: 100%;position: relative"
                    >
                        <div>
                            <el-input
                                    placeholder="可搜索"
                                    clearable
                                    style="position: absolute;z-index: 999;top: 0"
                                    v-model="selectCompanyPerson"
                                    @input="inputSelectCompanyPerson"
                            >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div v-if="selectCompanyPersonList.length===0">
                            <el-option value="" style="height: 36px"></el-option>
                        </div>
                        <div style="margin-top: 36px;margin-bottom: 10px">
                            <el-option
                                    v-for="item in selectCompanyPersonList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div style="display: flex;padding: 6px 0 0 0">
                <div style="flex: 0.2 0.2 0;height: 40px;line-height: 40px;">描述</div>
                <div style="flex: 0.8 0.8 0">
                    <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="对该公司的描述"
                            v-model="description">
                    </el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="addClientCompany">保存</el-button>
                <el-button type="primary" @click="addCompanyContinue">保存并继续新增</el-button>
            </div>
        </el-dialog>
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="500px">
            <span>更改工单模板之后模板属性中已填写的数据都将被清空，是否确认更改</span>
            <span slot="footer" class="dialog-footer">
    <el-button @click="cacelModifyTemplate">取 消</el-button>
    <el-button type="primary" @click="modifyOrderTempalte">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import ModifyWorkOrderAttr from "./modifyworkorderattr/ModifyWorkOrderAttr";
    import InternalRemarks from "./internalremarks/InternalRemarks";
    import VueUeditorWrap from 'vue-ueditor-wrap'
    export default {
        name: "EditWorkOrder",
        components: {InternalRemarks, ModifyWorkOrderAttr,VueUeditorWrap},
        data(){
            return{
                dialogFormVisible:false,
                dialogVisible1:false,
                dialogVisible2:false,
                dialogVisible:false,
                dialogFormVisible1:false,
                dialogFormVisible2:false,
                orderTemplate:'',
                orderTemplate2:'',
                userName:'',
                singeText:[],
                casca:[],
                selectFiled:[],
                editRadio:[],
                editCheck:[],
                textarea:[],
                editDate:[],
                editTime:[],
                dateTime:'',
                editCascade:[],
                myConfig: {
                    autoHeightEnabled: false, // 编辑器不自动被内容撑高
                    initialFrameHeight: 170, // 初始容器高度
                    initialFrameWidth: 'auto', // 初始容器宽度
                    UEDITOR_HOME_URL: ' /ueditor/',
                    serverUrl: "/ueditor-api/",
                    enableAutoSave: false,
                    autoFloatEnabled:false,
                    imageScaleEnabled:false,
                    toolbars: [
                        [
                            'undo', //撤销
                            'bold', //加粗
                            'indent', //首行缩进
                            'italic', //斜体
                            'underline', //下划线
                            'strikethrough', //删除线
                            'subscript', //下标
                            'superscript', //上标
                            'formatmatch', //格式刷
                            'fontfamily', //字体
                            'fontsize', //字号
                            'justifyleft', //居左对齐
                            'justifycenter', //居中对齐
                            'justifyright', //居右对齐
                            'justifyjustify', //两端对齐
                            'insertorderedlist', //有序列表
                            'insertunorderedlist', //无序列表
                            'forecolor', //字体颜色
                            'backcolor', //背景色
                            'lineheight',//行间距
                            'link', //超链接
                            'simpleupload', //单图上传
                            'insertvideo', //视频
                            'attachment', //附件上传
                            'fullscreen'
                        ]
                    ],
                    'fontfamily':[
                        { label:'',name:'songti',val:'宋体,SimSun'},
                        { label:'仿宋',name:'fangsong',val:'仿宋,FangSong'},
                        { label:'仿宋_GB2312',name:'fangsong',val:'仿宋_GB2312,FangSong'},
                        { label:'',name:'kaiti',val:'楷体,楷体_GB2312, SimKai'},
                        { label:'',name:'yahei',val:'微软雅黑,Microsoft YaHei'},
                        { label:'',name:'heiti',val:'黑体, SimHei'},
                        { label:'',name:'lishu',val:'隶书, SimLi'},
                        { label:'',name:'andaleMono',val:'andale mono'},
                        { label:'',name:'arial',val:'arial, helvetica,sans-serif'},
                        { label:'',name:'arialBlack',val:'arial black,avant garde'},
                        { label:'',name:'comicSansMs',val:'comic sans ms'},
                        { label:'',name:'impact',val:'impact,chicago'},
                        { label:'',name:'timesNewRoman',val:'times new roman'}
                    ],
                },
                myConfig1: {
                    autoHeightEnabled: false, // 编辑器不自动被内容撑高
                    initialFrameHeight: 170, // 初始容器高度
                    initialFrameWidth: 'auto', // 初始容器宽度
                    UEDITOR_HOME_URL: ' /ueditor/',
                    serverUrl: "/ueditor-api/",
                    enableAutoSave: false,
                    autoFloatEnabled:false,
                    imageScaleEnabled:false,
                    zIndex:1000,
                    toolbars: [
                        [
                            'undo', //撤销
                            'bold', //加粗
                            'indent', //首行缩进
                            'italic', //斜体
                            'underline', //下划线
                            'strikethrough', //删除线
                            'subscript', //下标
                            'superscript', //上标
                            'formatmatch', //格式刷
                            'fontfamily', //字体
                            'fontsize', //字号
                            'justifyleft', //居左对齐
                            'justifycenter', //居中对齐
                            'justifyright', //居右对齐
                            'justifyjustify', //两端对齐
                            'insertorderedlist', //有序列表
                            'insertunorderedlist', //无序列表
                            'forecolor', //字体颜色
                            'backcolor', //背景色
                            'lineheight',//行间距
                            'link', //超链接
                            'simpleupload', //单图上传
                            'insertvideo', //视频
                            'attachment', //附件上传
                            'fullscreen'
                        ]
                    ],
                    'fontfamily':[
                        { label:'',name:'songti',val:'宋体,SimSun'},
                        { label:'仿宋',name:'fangsong',val:'仿宋,FangSong'},
                        { label:'仿宋_GB2312',name:'fangsong',val:'仿宋_GB2312,FangSong'},
                        { label:'',name:'kaiti',val:'楷体,楷体_GB2312, SimKai'},
                        { label:'',name:'yahei',val:'微软雅黑,Microsoft YaHei'},
                        { label:'',name:'heiti',val:'黑体, SimHei'},
                        { label:'',name:'lishu',val:'隶书, SimLi'},
                        { label:'',name:'andaleMono',val:'andale mono'},
                        { label:'',name:'arial',val:'arial, helvetica,sans-serif'},
                        { label:'',name:'arialBlack',val:'arial black,avant garde'},
                        { label:'',name:'comicSansMs',val:'comic sans ms'},
                        { label:'',name:'impact',val:'impact,chicago'},
                        { label:'',name:'timesNewRoman',val:'times new roman'}
                    ],
                },
                ueditor:'',
                addprioritySelect:'',
                showaddprioritySelect:'',
                prioritySelect:[
                    {
                        value:'紧急',
                        label:'紧急'
                    },
                    {
                        value:'高',
                        label:'高'
                    },
                    {
                        value:'中',
                        label:'中'
                    },
                    {
                        value:'低',
                        label:'低'
                    }
                ],
                addstatusSelect:'',
                showaddstatusSelect:'',
                customerInput:'',
                editCustomer:'',
                editClientName:'',

                editaccpgroup:'',
                showeditaccpgroup:'',
                accpgroupInput:'',
                editaccpperson:'',

                accppersonInput:'',
                responsePerson:[],

                responsePersonInput:'',
                clientDescription:'',
                lookWorkOrder:1,
                isBlue:1,
                workOrderTemplateList:[],
                templateDetail:[],
                workOrderTemplate:{},
                nextStatusList:[],
                clientList:[],
                selectClientList:[],
                acountGroupList:[],
                accountPersonList:[],
                accountPersons:[],
                editCustomerName:'',
                clientGrade:'',
                clientDetailInfo:{},
                editClientGroup:'',
                editClientPerson:'',
                filedSelectList:[],
                filedDateList:[],
                filedTimeList:[],
                filedSingeTextList:[],
                filedTextareaList:[],
                filedRadioList:[],
                filedCheckBoxList: [],
                filedCascadeList:[],
                clientName:'',
                levelRadio:'1',
                clientTel: '',
                clientMail:'',
                companyValue:'',
                inputSelect: '',
                groupValue:'',
                accountGroup:{
                    list:[]
                },
                personValue:'',
                accountPerson:{
                    list:[]
                },
                describe:'',
                clientLevel:'',
                newStatus:{
                    list:[]
                },
                priorityStatus:'',
                company:{
                    list:[]
                },
                companyName:'',
                emailSuffix:'',
                contactPerson:'',
                contactPersonMail:'',
                contactPersonTel:'',
                description:'',
                CompanyLevelRadio:'1',
                companyGroupValue:'',
                companyPersonValue:'',
                grade:'',
                themeName:'',
                editThemeName:'',
                themeDescribe:'',
                editThemeDescribe:'',
                createTime:'',
                clientCompanyName:'',
                priority:'',
                priorityInfoList:[],
                statusInfoList:[],
                modifyLogList:[],
                replayList:[],
                addOrderFieldCascadeList1:[],
                addOrderFieldCascadeList2:[],
                optionSelect2List:[],
                optionSelect3List:[],
                cascadeOption1:[],
                cascadeOption2:[],
                cascadeOption3:[],
                cascade2Option1:[],
                cascadeList:[],
                fieldList:[],
                clientAccountPersonList:[],
                refrsh:0,
                copyUrl:'',
                editEamil:1,
                inputEamil:'',
                inputEamilNew:'',
                path:'',
                showClientSelect:'',
                pageSize:10000,
                currentPage:1,
                selectGroupList:[],
                selectOrderPersonList:[],
                selectFocusPersonList:[],
                mouseOverNameNum:'',
                inputName:'',
                clientGradeType:'',
                gradeType:'',
                clientGradeModel:'',
                mouseTel:'',
                inputTel:'',
                mouseMail:'',
                inputMail:'',
                mouseCompany:'',
                inputCompany:'',
                mouseGroup:'',
                mousePerson:'',
                editClientPersonName:'',
                groupName:'',
                orderClient:'',
                orderStastus:'',
                orderPriority:'',
                orderStatusName:'',
                orderPerson:'',
                orderFocusPerson:'',
                orderGroupName:'',
                orderFocusPersonName:'',
                orderPersonName:'',
                selectCompanyList:[],
                ClientCompanyValue:'',
                secondOption:0,
                thirdOption:[],
                test:'',
                getTem:0,
                introduce: '',
                // 是否展示所有文本内容
                showTotal: true,
                // 显示展开还是收起
                exchangeButton: true,
                // 是否显示展开收起按钮
                showExchangeButton: false,
                rem: '',
                containHeight:'',
                addstatusSelectClose:'',
                currentCustomerItem:{},
                addClientSuccess:false,
                addCompanySuccess:false,
                selectCompany:'',
                selectClientGroup:'',
                selectClientPerson:'',
                selectClientGroupList:[],
                selectClientPersonList:[],
                selectCompanyGroup:'',
                selectCompanyPerson:'',
                selectCompanyGroupList:[],
                selectCompanyPersonList:[],
                showaaaa:0,
                showPriority:0,
                showClient:0,
                showGroup:0,
                showPerson:0,
                showFocusPerson:0,
                selectShow:0,
                priorityShow:0,
                clientShow:0,
                groupShow:0,
                personShow:0,
                focusPersonShow:0,
                detailOrderDefaultField:[],
                filterOrderList:[],
                orderPageSize:1000,
                source:'',
                orderTackerClick:true,
                showPreview:false,
                previewImageUrl:'',
                creatorName:'',
                disableds:true,
              filed:{
                  list:[]
              },
              changeTemplate:0
            }
        },
       mounted() {
            this.$nextTick(() => {
                window.previewImage=this.previewImage

            })
            this.getWorkOrderDetail()
            this.getWorkOrderTemplate()
            this.getClientCompany()
            this.getCompanyAccountPerson()
          localStorage.setItem("detail",'true');
            /*let descHeight = window.getComputedStyle(this.$refs.desc).maxHeight.replace('px', '');
            this.containHeight=descHeight
            console.log(this.$refs.desc.clientHeight)
            console.log('descHeight:' + descHeight);*/

        },
      destroyed(){

      },
        updated() {
            let a=document.getElementsByClassName('merchant-desc')
            for (let i=0;i < a.length;i++)
            {
                for (let j=0;j<a[i].children.length;j++)
                {
                    let aa=a[i].children[j].getElementsByTagName('a')
                    for (let k=0;k< aa.length;k++)
                    {
                        aa[k].setAttribute('download',aa[k].attributes[2].value)
                        aa[k].setAttribute('target','_blank')

                    }


                    /* this.$set(aa[0],'download','')*/

                }
            }
        },
        watch:{
            'themeDescribe': function () {
                this.$nextTick(function () {
                    console.log('nextTick');
                    // 判断介绍是否超过四行
                    let rem = parseFloat(this.getRem());
                    console.log('watch 中的rem', rem);
                    if (!this.$refs.desc) {
                        console.log('desc null');
                        return;

                    }

                    let descHeight = window.getComputedStyle(this.$refs.desc).height.replace('px', '');
                    console.log('descHeight:' + descHeight);
                    console.log('如果 descHeight 超过' + (1.25 * rem) + '就要显示展开按钮');
                    if (descHeight > 1.25 * rem) {
                        console.log('超过了四行');
                        // 显示展开收起按钮
                        this.showExchangeButton = true;
                        this.exchangeButton = true;
                        // 不是显示所有
                        this.showTotal = false;
                    } else {
                        // 不显示展开收起按钮
                        this.showExchangeButton = false;
                        // 没有超过四行就显示所有
                        this.showTotal = true;
                        console.log('showExchangeButton', this.showExchangeButton);
                        console.log('showTotal', this.showTotal);
                    }
                }.bind(this));
            },
            'ueditor':function (a)
            {
              console.log(a)
              if(a!=='')
                this.disableds=false
              else
                this.disableds=true
            }
        },
        filters:{
            clientSourcetype(value){
                if(value==='ADD_MANULLY' || value === 'EXCEL_UPLOAD')
                    return '人工录入'
                if(value==='ADD_BATCH')
                    return '批量导入'
                if(value === 'ASKBOT_DIALOG_FORM')
                  return '客户提交'
            },
            gradeType(value){
                if(value==='VIP')
                    return 'VIP'
                if(value==='NORMAL')
                   return '普通'
            },
            priorityType(value){
                if(value==='URGENT')
                    return '紧急'
                if(value==='HIGH')
                    return '高'
                if(value==='MIDDLE')
                    return '中'
                if(value==='LOW')
                    return '低'

            }
        },
        methods:{

            //获取过滤器下的工单
            previewImage(_this) {

                 this.showPreview = true;
                 this.previewImageUrl = _this.src;
            },
            ready() {

            },
            showTotalIntro () {
                this.showTotal = !this.showTotal;
                this.exchangeButton = !this.exchangeButton;
            },
            getRem () {
                const defaultRem = 16;
                let winWidth = window.innerWidth;
               /* let rem = winWidth / 375 * defaultRem;*/
                let rem = winWidth / 375 * defaultRem
                return rem;
            },
            init () {
                this.introduce =this.themeDescribe
            },
            backClick(){
                this.$router.back()
            },
            lookWorkOrderClick(){
                this.lookWorkOrder=1
            },
           /* remarkClick(){
                this.isBlue=1
            },
            emailResClick(){
                this.isBlue=0
            },*/

            backReplyWorkOrder(){
                this.lookWorkOrder=0
            },
            //点击修改用户邮箱
            riveseClick(){

                if(this.editCustomerName!=='')
                {
                    this.editEamil=0
                    if(this.clientDetailInfo.mail===undefined)
                    {
                        this.inputEamil=this.inputEamilNew
                        this.clientDetailInfo.mail=this.inputEamilNew
                    }
                    else
                        this.inputEamil=this.clientDetailInfo.mail
                }
                else
                    this.$message.error('请先选择客户')






                /*this.$refs.userName.contentEditable = true
                this.$refs.userEmail.contentEditable = true*/
            },
            //修改用户邮箱
            inputEamilFinish(){

                    this.editEamil=1
                if(this.inputEamil!=='')
                {
                    this.clientDetailInfo.mail=this.inputEamil
                    this.inputEamilNew=this.inputEamil
                }





            },
            modifyClientDesc(){
                let clientData=this.currentCustomerItem;

                clientData.description=this.clientDescription;
                this.$http.put('/api/client/'+clientData.id,clientData)
                    .then(res=>{
                        if(res.data.code==='0'){
                            this.$message.success('修改用户信息成功')
                        }
                    })
            },
            //修改工单
            modifyWorkOrder(){
                let fieldValue={}
                    for(let i=0;i<this.detailOrderDefaultField.length;i++){

                            if(this.detailOrderDefaultField[i].field.type==='DATE_PICKER')
                            {

                                     fieldValue[this.detailOrderDefaultField[i].fieldId]=this.editDate[i]
                            }
                        if(this.detailOrderDefaultField[i].field.type==='TIME_PICKER')
                        {

                                fieldValue[this.detailOrderDefaultField[i].fieldId]=this.editTime[i]
                        }
                        if(this.detailOrderDefaultField[i].field.type==='INPUT'){
                            fieldValue[this.detailOrderDefaultField[i].fieldId]=this.singeText[i]
                        }
                        if(this.detailOrderDefaultField[i].field.type==='TEXTAREA'){
                            fieldValue[this.detailOrderDefaultField[i].fieldId]=this.textarea[i]
                        }
                        if(this.detailOrderDefaultField[i].field.type==='SELECT')
                        {
                            fieldValue[this.detailOrderDefaultField[i].fieldId]=this.selectFiled[i]
                        }
                        if(this.detailOrderDefaultField[i].field.type==='CASCADER'){

                                fieldValue[this.detailOrderDefaultField[i].fieldId]=this.cascade2Option1[i]
                        }

                        if(this.detailOrderDefaultField[i].field.type==='RADIO')
                        {
                                fieldValue[this.detailOrderDefaultField[i].fieldId]=this.editRadio[i]
                        }
                        if(this.detailOrderDefaultField[i].field.type==='CHECKBOX')
                        {
                                fieldValue[this.detailOrderDefaultField[i].fieldId]=this.editCheck[i]
                        }
                    }
                    console.log(fieldValue)
              for (let i=0;i<this.detailOrderDefaultField.length;i++)
              {
                if(this.detailOrderDefaultField[i].required===true){

                  if(fieldValue[this.detailOrderDefaultField[i].fieldId]===undefined || fieldValue[this.detailOrderDefaultField[i].fieldId]===''||fieldValue[this.detailOrderDefaultField[i].fieldId]===null||fieldValue[this.detailOrderDefaultField[i].fieldId].length ===0)
                  {
                    this.$message.error( this.detailOrderDefaultField[i].field.name+'是必填的')
                    return
                  }
                }
              }
                if(this.addprioritySelect==='紧急'||this.addprioritySelect==='URGENT')
                    this.priority='URGENT'
                if(this.addprioritySelect==='HIGH'||this.addprioritySelect==='高')
                    this.priority='HIGH'
                if(this.addprioritySelect==='LOW'||this.addprioritySelect==='低')
                    this.priority='LOW'
                if(this.addprioritySelect==='MIDDLE'|| this.addprioritySelect==='中')
                    this.priority='MIDDLE'
              console.log(this.$route.query.id)
                if(this.editThemeName!=='')
                {
                    if(this.editThemeDescribe!=='')
                    {
                        this.editThemeDescribe=this.editThemeDescribe.replace(/img/g, "img onclick='previewImage(this)' ");
                        this.$http.put('/api/order/'+this.$route.query.id,{
                            assigneeGroupId: this.editaccpgroup,
                            assigneeId: this.editaccpperson,
                            clientId: this.editCustomer,
                            description: this.editThemeDescribe,
                            fieldValue: fieldValue,
                            followersId:this.responsePerson,
                            name: this.editThemeName,
                            priority: this.priority,
                            statusId: this.addstatusSelect,
                            templateId: this.orderTemplate,
                            source:'ADD_MANULLY'
                        }).then(res=>{
                            if(res.data.code==='0')
                            {
                              this.$message.success('您修改了工单的信息')
                              this.refrsh=1
                              this.getWorkOrderDetail()
                              this.getNextStatus()
                            }
                        })
                        this.orderClient=''
                        this.orderStastus=''
                        this.orderPriority=''
                        this.orderPerson=''
                        this.orderFocusPerson=''
                    }
                    else
                        this.$message.error('工单描述不能为空')
                }
                else
                    this.$message.error('工单主题不能为空')
            },
            //修改客户详情
            modifyClient(){
                /*if(this.clientGrade==='VIP')
                    this.grade='VIP'
                if(this.clientGrade==='普通')
                    this.grade='NORMAL'*/
                if(Object.keys(this.clientDetailInfo).length===0)
                {
                    this.clientDetailInfo.tel=''
                    this.clientDetailInfo.companyId=''
                    this.clientDetailInfo.mail=''
                    this.clientDetailInfo.createTime=''
                }
                this.$http.put('/api/client/'+this.editCustomer,{
                    createTime:this.clientDetailInfo.createTime,
                    updateTime:new Date(),
                    name:this.editCustomerName,
                    grade:this.clientGradeModel,
                    tel:this.clientDetailInfo.tel,
                    mail:this.clientDetailInfo.mail,
                    groupId: this.editClientGroup,
                    principalId: this.editClientPerson,
                    companyId: this.ClientCompanyValue,
                    clientSource: 'ADD_MANULLY',
                    description: this.describe
                }).then(res=>{
                    if(res.data.code==='0')
                        this.$message.success('您修改了客户详情信息')
                })
                this.getClient()
            },
            //获取详情的工单并赋初值
            getWorkOrderDetail(){

                this.$http.get('/api/order/detail?id='+this.$route.query.id).then(res=>{
                    this.filedSelectList=[]
                    this.filedDateList=[]
                    this.filedTimeList=[]
                    this.filedSingeTextList=[]
                    this.filedTextareaList=[]
                    this.filedRadioList=[]
                    this.filedCheckBoxList=[]
                    this.addOrderFieldCascadeList2=[]
                    this.replayList=[]
                    this.editaccpperson=''
                    this.templateDetail=res.data.data
                    this.themeName=this.templateDetail.name
                    this.editThemeName=this.templateDetail.name
                    this.introduce=this.templateDetail.description
                    this.themeDescribe=this.templateDetail.description
                    console.log('详情工单',this.templateDetail)
                    this.editThemeDescribe=this.templateDetail.description
                  if(this.templateDetail.status!==null)
                  {
                    this.addstatusSelect=this.templateDetail.status.id
                    this.showaddstatusSelect=this.templateDetail.status.name
                  }
                  console.log(this.templateDetail.priority)
                  if(this.templateDetail.priority!==null)
                  {
                    this.addprioritySelect=this.templateDetail.priority
                  }
                    this.orderTemplate=this.templateDetail.templateId
                    this.orderTemplate2=this.templateDetail.templateId
                    if(this.templateDetail.priority==='HIGH')
                    {
                        this.showaddprioritySelect='高'
                        this.addprioritySelect='高'
                    }
                    if(this.templateDetail.priority==='LOW')
                    {
                        this.showaddprioritySelect='低'
                        this.addprioritySelect='低'
                    }
                    if(this.templateDetail.priority==='URGENT') {
                        this.showaddprioritySelect = '紧急'
                        this.addprioritySelect='紧急'
                    }
                    if(this.templateDetail.priority==='MIDDLE') {
                        this.showaddprioritySelect = '中'
                        this.addprioritySelect='中'
                    }
                    if(this.templateDetail.clientId!==null)
                    {
                        this.editCustomer=this.templateDetail.clientId
                    }

                    if(this.templateDetail.assigneeGroupId!==null)
                    {
                        this.editaccpgroup=this.templateDetail.assigneeGroupId
                    }
                    if(this.templateDetail.assignee!==null)
                    {
                        this.editaccpperson=this.templateDetail.assigneeId
                    }
                    if(this.templateDetail.followersId!=null)
                    {
                        this.responsePerson=this.templateDetail.followersId
                    }
                    if(this.templateDetail.creator!==null)
                    {
                        this.creatorName=this.templateDetail.creator.name
                    }

                  if(this.templateDetail.template.workOrderFieldList!==null)
                  {
                    this.$http.get('/api/field/list').then(res => {
                      this.filed.list = res.data.data
                      let add=this.templateDetail.template.workOrderFieldList.fieldTwoDimensionalList[0].filter(item=>this.filed.list.some(ele=>ele.id === item.fieldId))
                      this.detailOrderDefaultField=add
                      for(let i =0 ;i < this.detailOrderDefaultField.length;i++ ){
                        this.editCheck.push([])
                      }
                      console.log('工单详情下的工单模板',this.detailOrderDefaultField)
                      console.log('详情工单',this.templateDetail)
                      if(this.templateDetail.fieldValue!==null)
                      {
                        for(let i =0 ;i < this.detailOrderDefaultField.length;i++ ){

                          if(this.detailOrderDefaultField[i].field.type==='TIME_PICKER')
                          {
                            if(this.detailOrderDefaultField[i].fieldId in this.templateDetail.fieldValue)
                              this.editTime[i]=this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]
                            else if(this.detailOrderDefaultField[i].defaultValue!==null){
                              this.editTime[i]=this.detailOrderDefaultField[i].defaultValue
                            }
                          }
                          if(this.detailOrderDefaultField[i].field.type==='DATE_PICKER')
                          {
                            if (this.detailOrderDefaultField[i].fieldId in this.templateDetail.fieldValue)
                              this.editDate[i] = this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]
                            else if(this.detailOrderDefaultField[i].defaultValue!==null){
                              this.editDate[i]=this.detailOrderDefaultField[i].defaultValue
                            }
                          }
                          if(this.detailOrderDefaultField[i].field.type==='INPUT')
                          {
                            if(this.detailOrderDefaultField[i].fieldId in this.templateDetail.fieldValue)
                              this.singeText[i]=this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]
                            else if(this.detailOrderDefaultField[i].defaultValue!==null){
                              this.singeText[i]=this.detailOrderDefaultField[i].defaultValue
                            }
                          }
                          if(this.detailOrderDefaultField[i].field.type==='TEXTAREA')
                          {
                            if(this.detailOrderDefaultField[i].fieldId in this.templateDetail.fieldValue)
                              this.textarea[i]=this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]
                            else if(this.detailOrderDefaultField[i].defaultValue!==null){
                              this.textarea[i]=this.detailOrderDefaultField[i].defaultValue
                            }
                          }
                          if(this.detailOrderDefaultField[i].field.type==='SELECT')
                          {
                            if(this.detailOrderDefaultField[i].fieldId in this.templateDetail.fieldValue)
                              this.selectFiled[i]=this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]
                            else if(this.detailOrderDefaultField[i].defaultValue!==null){
                              this.selectFiled[i]=this.detailOrderDefaultField[i].defaultValue
                            }
                          }
                          if(this.detailOrderDefaultField[i].field.type==='RADIO')
                          {
                            if(this.detailOrderDefaultField[i].fieldId in this.templateDetail.fieldValue)
                              this.editRadio[i]=this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]
                            else if(this.detailOrderDefaultField[i].defaultValue!==null){
                              this.editRadio[i]=this.detailOrderDefaultField[i].defaultValue
                            }
                          }
                          if(this.detailOrderDefaultField[i].field.type==='CHECKBOX')
                          {
                            if(this.detailOrderDefaultField[i].fieldId in this.templateDetail.fieldValue)
                              this.editCheck[i]=this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]
                            else if(this.detailOrderDefaultField[i].defaultValue!==null){
                              this.editCheck[i]=this.detailOrderDefaultField[i].defaultValue
                            }
                          }
                          if(this.detailOrderDefaultField[i].field.type==='CASCADER')
                          {
                            console.log(this.detailOrderDefaultField[i].fieldId)
                            if(this.detailOrderDefaultField[i].fieldId in this.templateDetail.fieldValue)
                            {
                              this.cascade2Option1[i]=this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]
                              console.log(this.cascade2Option1[i])
                            }
                            else if(this.detailOrderDefaultField[i].defaultValue!==null){
                              this.cascade2Option1[i]=this.detailOrderDefaultField[i].defaultValue
                            }
                            /* this.cascade2Option1[i]=this.templateDetail.fieldValue[this.detailOrderDefaultField[i].fieldId]*/
                          }

                        }
                      }
                      this.getNextStatus()
                      this.templateDetail.template.workOrderFieldList.fieldTwoDimensionalList[0].forEach((item)=>{

                        if(item.field.type==='SELECT')
                          this.filedSelectList.push(item)
                        if(item.field.type==='DATE_PICKER')
                          this.filedDateList.push(item)
                        if(item.field.type==='TIME_PICKER')
                          this.filedTimeList.push(item)
                        if(item.field.type==='INPUT')
                          this.filedSingeTextList.push(item)
                        if(item.field.type==='TEXTAREA')
                          this.filedTextareaList.push(item)
                        if(item.field.type==='RADIO')
                          this.filedRadioList.push(item)
                        if(item.field.type==='CHECKBOX')
                        {
                          this.filedCheckBoxList.push(item)
                        }
                      })


                    })
                  }
                    if(this.editaccpgroup!=='')
                    {
                        this.$http.get('/api/account/principal?groupId='+this.editaccpgroup).then(res=>{
                            this.accountPersonList=res.data.data
                            this.selectOrderPersonList=res.data.data
                            this.selectOrderPersonList.forEach(item=>{
                                if(item.id===this.templateDetail.assigneeId)
                                {

                                    this.editaccpperson=item.id
                                    this.orderPersonName=item.name
                                }

                            })
                        })
                    }
                    if(this.editaccpgroup==='')
                    {
                        this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                            this.accountPersonList=res.data.data
                            this.selectOrderPersonList=res.data.data
                            this.accountPersonList.forEach(item=>{
                                if(item.id===this.templateDetail.assigneeId)
                                {
                                    this.editaccpperson=item.id
                                    this.orderPersonName=item.name
                                }

                            })
                        })
                    }

                    this.modifyLogList=[]
                    this.templateDetail.workOrderChangeLogs.forEach(item=>{
                        if(item.changeType==='ATTRIBUTE'||item.changeType==='FIELD'||item.changeType==='REMIND')
                            this.modifyLogList.push(item)
                        else
                            this.replayList.push(item)
                    })
                    console.log("================",this.modifyLogList);
                    this.getClient()
                    this.getAccountGroup()
                    this.getWorkOrderAccPerson()
                    this.getAccountPersons()
                  console.log( this.addprioritySelect)
                })
            },
            //获取下一级的状态
            getNextStatus(){
              if(this.templateDetail.status!==null)
              {
                this.$http.get('/api/status/list?currentId='+this.templateDetail.status.id).then(res=>{
                  this.nextStatusList=res.data.data
                  if(this.templateDetail.status!==null)
                  {
                    this.nextStatusList.push(this.templateDetail.status)
                  }


                })
              }
              console.log(this.nextStatusList)

            },
            //获取全部工单模板
            getWorkOrderTemplate(){
                this.$http.get('/api/template/list').then(res=>{
                    this.workOrderTemplateList=res.data.data

                   /* this.workOrderTemplateList.find(item=>{
                        if(item.id===this.templateDetail.templateId)
                        {
                            this.workOrderTemplate=item
                            this.orderTemplate=item.id
                            console.log(this.workOrderTemplate)
                        }

                    })*/


                })

            },
            //获取客户
            getClient(){
                this.$http.get('/api/client/page?num='+this.pageSize+'&page='+this.currentPage).then(res=>{
                    this.clientList=res.data.data.content
                    this.selectClientList=res.data.data.content

                    this.clientList.forEach(item=>{
                            if(item.id===this.editCustomer)
                            {
                                this.currentCustomerItem=item;
                                this.clientDescription=item.description;
                                this.editCustomerName=item.name
                                this.createTime=item.createTime
                                this.clientGradeModel=item.grade
                                if(item.grade==='VIP')
                                    this.clientGrade='VIP'
                                if(item.grade==='NORMAL')
                                    this.clientGrade='普通'
                                this.clientDetailInfo=item
                                this.editClientGroup=item.groupId
                                if(item.group!==null)
                                {
                                    this.groupName=item.group.name
                                }

                                this.getClientPerson()
                                this.editClientPerson=item.principalId
                                if(item.principal!==null)
                                {
                                    this.editClientPersonName=item.principal.name
                                }
                                this.ClientCompanyValue=item.companyId
                                if(this.clientDetailInfo.companyId!=='')
                                {
                                    this.clientCompanyName=this.clientDetailInfo.company.name

                                }



                            }
                    })
                    if(this.addClientSuccess===true)
                    {
                        let length=this.clientList.length
                        this.editCustomer=this.clientList[length - 1].id
                        this.editCustomerName=this.clientList[length - 1].name
                        this.modifyWorkOrder()
                    }
                    this.addClientSuccess=false

                })

            },

            //获取客户的受理人
            getClientPerson(){
                this.$http.get('/api/account/principal?groupId='+this.editClientGroup).then(res=>{
                    this.clientAccountPersonList=res.data.data
                })
                this.mouseGroup=''
            },

            //获取受理组
            getAccountGroup(){
                this.$http.get('/api/account/group').then(res=>{
                    this.acountGroupList=res.data.data
                    this.selectGroupList=res.data.data
                    this.acountGroupList.forEach(item=>{
                        if(item.id===this.editaccpgroup)
                            this.showeditaccpgroup=item.name
                    })
                })
            },

            //获取受理人
            getAccountPerson(){
                if(this.editaccpgroup!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.editaccpgroup).then(res=>{
                        this.accountPersonList=res.data.data
                        this.selectOrderPersonList=res.data.data
                    })
                }
                if(this.editaccpgroup==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPersonList=res.data.data
                        this.selectOrderPersonList=res.data.data
                    })
                }

            },
            //获取工单初始受理人
            getWorkOrderAccPerson(){
                if(this.templateDetail.assigneeGroupId!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.templateDetail.assigneeGroupId).then(res=>{
                        this.accountPersonList=res.data.data
                        this.selectOrderPersonList=res.data.data
                        this.selectOrderPersonList.forEach(item=>{

                            if(item.id===this.templateDetail.assigneeId)
                            {

                                this.editaccpperson=item.id
                            }

                        })
                    })
                }
                if(this.templateDetail.assigneeGroupId==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPersonList=res.data.data
                        this.selectOrderPersonList=res.data.data
                        this.selectOrderPersonList.forEach(item=>{

                            if(item.id===this.templateDetail.assigneeId)
                            {

                                this.editaccpperson=item.id
                            }

                        })
                    })
                }

                    /*this.editaccpgroup=this.templateDetail.assigneeGroupId*/

            },
            //获取关注人

            getAccountPersons(){
                this.$http.get('/api/account/principals?groupIds=%20').then(res=>{
                    this.accountPersons=res.data.data
                    this.selectFocusPersonList=res.data.data
                    this.orderFocusPersonName=''
                    this.selectFocusPersonList.forEach(item=>{
                        this.responsePerson.forEach(items=>{

                            if(item.id ===items)
                            {

                                this.orderFocusPersonName+=item.name+','
                            }
                        })
                    })
                    this.orderFocusPersonName= this.orderFocusPersonName.slice(0,this.orderFocusPersonName.length-1)
                })
            },

            //下拉获取工单
            getTemplate(value){
                if(this.templateDetail.templateId!==value)
                {
                   this.dialogVisible=true
                }
            },
            //确定修改工单模板
            modifyOrderTempalte(){
               this.cascadeOption2=''
               this.cascadeOption1=''
               this.cascadeOption3=''
               this.filedDateList=[]
               this.filedTimeList=[]
               this.filedSingeTextList=[]
               this.filedTextareaList=[]
               this.filedSelectList=[]
               this.filedRadioList=[]
               this.filedCheckBoxList=[]
               this.addOrderFieldCascadeList2=[]
               this.addOrderFieldCascadeList1=[]
               this.secondOption=0
               this.thirdOption=0
               this.detailOrderDefaultField=[]
               this.modifyWorkOrder()
              this.dialogVisible=false

            },
            //取消修改工单模板
            cacelModifyTemplate(){
                this.orderTemplate=this.templateDetail.templateId
                this.dialogVisible=false
            },
            //删除工单
            deleteTemplate(){
                this.$http.delete('/api/order/'+this.$route.query.id).then(res=>{
                    if(res.data.code==='0')
                    {
                        this.$message.success('删除工单成功')
                        setTimeout( ()=> {
                            this.$router.back()
                        },2000)

                    }
                    else
                        this.$message('删除工单失败')

                })
                this.dialogVisible1 = false
            },

            addClientBtn(){
                this.clientName=''
                this.levelRadio='1'
                this.clientTel=''
                this.clientMail=''
                this.groupValue=''
                this.personValue=''
                this.companyValue=''
                this.describe=''
                this.getClientAccountGroup()
                this.getClientAccountPerson()
                this.dialogFormVisible=true
            },
            //新增客户
            addClient(){
                if(this.levelRadio==='1'){
                    this.clientLevel='NORMAL'
                }
                if(this.levelRadio==='2'){
                    this.clientLevel='VIP'
                }
                if(this.clientName!=='')
                {
                    this.$http.post('/api/client', {

                        name:this.clientName,
                        grade:this.clientLevel,
                        tel:this.clientTel,
                        mail:this.clientMail,
                        groupId: this.groupValue,
                        principalId: this.personValue,
                        companyId: this.companyValue,
                        company:this.companyName,
                        clientSource: "ADD_MANULLY",
                        description:this.describe

                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加客户成功')
                            this.addClientSuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClient()
                        /*   console.debug('post field response:', res);*/

                    });
                    this.dialogFormVisible = false
                }
                else
                    this.$message('请输入客户名称')

            },

            addClientContinue(){
                if(this.levelRadio==='1'){
                    this.clientLevel='NORMAL'
                }
                if(this.levelRadio==='2'){
                    this.clientLevel='VIP'
                }
                if(this.clientName!=='')
                {
                    this.$http.post('/api/client', {

                        name:this.clientName,
                        grade:this.clientLevel,
                        tel:this.clientTel,
                        mail:this.clientMail,
                        groupId: this.groupValue,
                        principalId: this.personValue,
                        companyId: this.companyValue,
                        company:this.companyName,
                        clientSource: "ADD_MANULLY",
                        description:this.describe

                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加客户成功')
                            this.addClientSuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClient()
                        /*   console.debug('post field response:', res);*/

                    });
                    this.clientName=''
                    this.levelRadio='1'
                    this.clientTel=''
                    this.clientMail=''
                    this.groupValue=''
                    this.personValue=''
                    this.companyValue=''
                    this.describe=''
                    this.dialogFormVisible = true
                }
                else
                    this.$message('请输入客户名称')
            },
            //获取公司
            getClientCompany(){
                this.$http.get('/api/client-company/page?num='+this.pageSize+'&page='+this.currentPage)
                    .then(response => {
                        this.company.list = response.data.data.content;
                        this.selectCompanyList=response.data.data.content;
                        this.company.total=response.data.data.totalElements
                        console.debug('FieldApiExample field page:', this.newClient);
                        if(this.addCompanySuccess===true)
                        {
                            let length=this.company.list.length
                            this.companyValue=this.company.list[length - 1].id

                        }
                    })
            },

            //获取客户的负责组下拉列表值
            getClientAccountGroup(){
                this.$http.get('/api/account/group').then(res=>{
                    this.accountGroup.list=res.data.data
                    this.selectClientGroupList=res.data.data
                    this.selectCompanyGroupList=res.data.data
                })
            },
            //获取负责人的下拉列表值
            getClientAccountPerson(){
                if(this.groupValue!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.groupValue).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectClientPersonList=res.data.data

                    })
                }
                if(this.groupValue==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectClientPersonList=res.data.data

                    })
                }

            },
            //获取公司的负责人
            getCompanyAccountPerson(){
                if(this.companyGroupValue!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.companyGroupValue).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectCompanyPersonList=res.data.data

                    })
                }
                if(this.companyGroupValue==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectCompanyPersonList=res.data.data

                    })
                }


            },

            createCompany(){
                this.companyName=''
                this.companyPersonValue=''
                this.contactPerson=''
                this.contactPersonMail=''
                this.contactPersonTel=''
                this.description=''
                this.emailSuffix=''
                this.CompanyLevelRadio='1'
                this.dialogFormVisible1=true
            },
            //新增公司
            addClientCompany(){
                if(this.CompanyLevelRadio==='1')
                    this.grade='NORMAL'
                if(this.CompanyLevelRadio==='2')
                    this.grade='VIP'
                if(this.companyName==='')
                    this.$message.error('请输入公司名称')
                else {

                    this.$http.post('/api/client-company', {

                        contactPerson: this.contactPerson,
                        contactPersonMail: this.contactPersonMail,
                        contactPersonTel: this.contactPersonTel,
                        description: this.description,
                        groupId: this.companyGroupValue,
                        name: this.companyName,
                        principalId: this.companyPersonValue,
                        grade: this.grade,
                        mailSuffix: this.emailSuffix,
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加公司成功')
                            this.addCompanySuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClientCompany()


                    });
                    this.dialogFormVisible1=false

                }

            },
            //新增并继续添加公司
            addCompanyContinue(){
                if(this.CompanyLevelRadio==='1')
                    this.grade='NORMAL'
                if(this.CompanyLevelRadio==='2')
                    this.grade='VIP'
                if(this.companyName==='')
                    this.$message('请输入公司名称')
                else {

                    this.$http.post('/api/client-company', {

                        contactPerson: this.contactPerson,
                        contactPersonMail: this.contactPersonMail,
                        contactPersonTel: this.contactPersonTel,
                        description: this.description,
                        groupId: this.companyGroupValue,
                        name: this.companyName,
                        principalId: this.companyPersonValue,
                        grade: this.grade,
                        mailSuffix: this.emailSuffix,
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加公司成功')
                            this.addCompanySuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClientCompany()
                    });
                    this.companyName=''
                    this.companyPersonValue=''
                    this.contactPerson=''
                    this.contactPersonMail=''
                    this.contactPersonTel=''
                    this.description=''
                    this.emailSuffix=''
                    this.CompanyLevelRadio='1'
                    this.dialogFormVisible1=true
                }

                /*   console.debug('post field response:', res);*/
            },
            //关闭工单,将工单状态改为已关闭
            closeWorkOrder(){
                  this.addstatusSelect=this.addstatusSelectClose
                  this.modifyWorkOrder()
                  this.$message.success('工单已关闭')
                 this.dialogVisible2=false
            },
            closeOrderStatus(){
              if(this.editThemeName!=='') {
                if (this.editThemeDescribe !== '') {
                  let Order=[]
                  for (let i=0;i<this.nextStatusList.length;i++)
                  {
                    if(this.nextStatusList[i].name==='已关闭')
                    {
                      Order.push(this.nextStatusList[i])
                    }
                    /*else
                    {
                        this.$message.error('您的工单状态中没有已关闭状态')
                    }*/
                  }
                  console.log(this.nextStatusList)
                  if(Order.length > 0)
                  {
                    Order.forEach(item=>{
                      if(item.id===this.addstatusSelect)
                      {
                        this.$message.warning('您的工单状态已经是已关闭状态了哦')
                      }
                      else
                      {
                        this.addstatusSelectClose=item.id
                        this.dialogVisible2=true
                      }
                    })
                    /* for (let i=0; i <Order.length;i++)
                     {
                         if(this.addstatusSelect===Order[i].id)
                         {
                             this.$message.warning('您的工单状态已经是已关闭状态了哦')
                         }
                         else
                         {
                             this.addstatusSelectClose=Order[i].id
                             this.dialogVisible2=true
                         }
                     }*/
                  }
                  else
                    this.$message.error('您的状态中没有已关闭状态')
                }
                else
                {
                  this.$message.error('工单描述不能为空')
                }
              }
              else
              {
                this.$message.error('工单主题不能为空')
              }
            },

            //修改工单主题
            modifyTheme(){
                this.getWorkOrderDetail()
                this.dialogFormVisible2=true
            },
            modifyThemeFinish(){
                this.modifyWorkOrder()
                if(this.themeName!=='')
                {
                    if(this.themeDescribe!=='')
                    {
                        this.dialogFormVisible2=false
                    }
                }

            },

            //受理组change的时候需要执行两个函数
            groupClick(){
                this.getAccountGroup()
                this.getAccountPerson()
                this.editaccpperson=''
                if(this.orderTackerClick===false)
                {
                    this.modifyWorkOrder()
                }

            },

            //回复信息的时候，向后端传输的数据
            postReply(){
                if(this.isBlue===1)
                {
                    this.ueditor=this.ueditor.replace(/img/g, "img onclick='previewImage(this)' ");
                    console.log(this.ueditor)
                    this.$http.put('/api/order/reply/'+this.$route.query.id,{
                      content: this.ueditor,
                      mail: "string",
                    }).then(res=>{
                      if(res.data.code==='0')
                      {
                        this.$message.success('回复成功')
                        this.ueditor=' '
                        this.source='内部备注'
                      }
                      this.getWorkOrderDetail()
                    })

                }

                    /*if(this.clientDetailInfo.mail!==undefined&&this.clientDetailInfo.mail!=='')
                    {

                        this.$http.put('/api/order/reply/'+this.$route.query.id,{
                            content: this.ueditor,
                            mail: this.clientDetailInfo.mail,
                            sendMail: true
                        }).then(res=>{
                            if(res.data.code==='0')
                            {
                                this.$message.success('回复成功')
                                this.ueditor=' '
                                this.source='邮件回复'
                            }

                            this.getWorkOrderDetail()
                        })
                    }
                    else
                        this.$message.error('暂无邮箱地址,请完善邮箱地址')
                */


            },
            //关注工单
            followOrder(){
                this.$http.put('/api/order/follow/'+this.$route.query.id).then(res=>{
                    if(res.data.code==='0')
                    {
                        this.$message.success('关注工单成功')
                        this.getWorkOrderDetail()
                        this.responsePerson=this.templateDetail.followersId
                    }
                })
            },
            orderTaker(){
                this.orderTackerClick=true
                    this.$http.put('api/order/accept/'+this.$route.query.id).then(res=>{
                        if(res.data.code==='0')
                        {
                            this.$message.success('接单成功')
                            this.getWorkOrderDetail()
                        }

                    })


            },
            //时间转换
            dateFormat(time){
                let date=new Date(time);
                let year=date.getFullYear();
                /* 在日期格式中，月份是从0开始的，因此要加0
                 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
                 * */
                let month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                let day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                let hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
                let minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
                let seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
                // 拼接
                return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
            },
           /* cascadeSelectOne(index,value)
            {
                this.addOrderFieldCascadeList1.forEach(item=>{
                    item.field.extInfo.cascadeDown[0].options.forEach(items=>{
                        if(items.value===value)
                        {

                            this.optionSelect2List[index]=items.children

                        }

                    })
                })
                if(this.cascadeOption1.length)
                {
                    let test=0
                    for (let i = 0; i <this.cascadeOption1.length;i++)
                    {
                        if(this.cascadeOption1[i]===value)
                        {
                            test=i

                        }

                    }
                    this.cascadeOption2[test]=''
                    this.cascadeOption3[test]=''
                    /!*   this.cascadeList[test].push(value)*!/

                }

            },*/
            //第三级下拉
           /* cascadeSelectTwo(index,value){
                this.optionSelect2List[index].forEach(item=>{
                    if(item.value===value)
                    {
                        this.optionSelect3List[index]=item.children

                    }


                })
                if(this.cascadeOption2.length)
                {
                    let test=0
                    for (let i = 0; i <this.cascadeOption2.length;i++)
                    {
                        if(this.cascadeOption2[i]===value)
                        {
                            test=i

                        }

                    }
                    this.cascadeOption3[test]=''
                    /!*  this.cascadeList[test].push(value)*!/
                }


            },*/
          /*  cascadeSelectThire(value){
                console.log(value)
                let d
                for (let i = 0 ;i <this.cascadeOption1.length;i++)
                {
                    d=[]
                    d[0]=this.cascadeOption1[i]
                    if(this.cascadeOption2[i]!==null)
                    {
                        d[1]=this.cascadeOption2[i]
                    }
                    if(this.cascadeOption3[i]!==null)
                    {
                        d[2]=this.cascadeOption3[i]
                    }
                    let t=[]
                    for (let i=0;i<d.length;i++)
                    {
                        if(d[i]!=='')
                        {
                            t[i]=d[i]
                        }
                    }
                    this.cascadeList[i]=t

                }
            },*/

            //获取自定义的字段

            getDefaultField(){
                this.$http.get('/api/field/list').then(res=>{
                    this.fieldList=res.data.data
                })
            },

            //催单
            remindWorkOrder(){
                this.$http.put('/api/order/remind/'+this.$route.query.id).then(res=>{
                    if(res.data.code==='0'){
                        this.$message.success('催单成功')
                        this.getWorkOrderDetail();
                    }else{
                        this.$message.error('催单失败')
                    }
                })
            },
            shareClick(){
                this.copyUrl='向您分享了工单'+'\n'+'工单主题: '+this.themeName+'\n'+'工单详情链接: '+window.location.href+'\n'
                this.$copyText(this.copyUrl)
            },
            onCopy() {
                this.$message.success('工单内容已复制，请发送给相关同事')
            },
          /*  beforeOrder(){
                let test=''
                for (let i=0;i<this.filterOrderList.length;i++)
                {
                    console.log(this.filterOrderList[i].id)

                    if(this.$route.query.id===this.filterOrderList[i].id)
                    {
                        test=i
                    }
                }
                if(test===0)
                {
                    this.$message.warning('已经是第一个了')
                }
                else
                {
                    this.$route.query.id=this.filterOrderList[test-1].id
                    this.getWorkOrderDetail()
                }

                console.log(this.$route.query.id)
            },
            afterOrder(){
                let test=''
                for (let i=0;i<this.filterOrderList.length;i++)
                {
                    console.log(this.filterOrderList[i].id)

                    if(this.$route.query.id===this.filterOrderList[i].id)
                    {
                        test=i
                    }
                }
                if(test===this.filterOrderList.length-1)
                {
                    this.$message.warning('已经是最后一个了')
                }
                else
                {
                    this.$route.query.id=this.filterOrderList[test+1].id
                    this.getWorkOrderDetail()
                }

                console.log(this.$route.query.id)
            },
            showSelect(){
                this.showClientSelect=1
                console.log('获取焦点')
            },
            outClientSelect(){
                console.log(this.editCustomer)
                if(this.editCustomer==='')
                    this.showClientSelect=''
            },*/
            changeSelectClient(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this.clientList.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectClientList=selectCompany

                }
                else
                {
                    this.selectClientList=this.clientList
                }
            },
            changeSelectOrderGroup(value){
                if(value!=='')
                {
                    let selectGroup=[]
                    this.acountGroupList.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectGroup.push(item)
                        }
                    })
                    this. selectGroupList=selectGroup

                }
                else
                {
                    this. selectGroupList=this.acountGroupList
                }

            },
            changeSelectOrderPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this.accountPersonList.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this. selectOrderPersonList=selectPerson

                }
                else
                {
                    this. selectOrderPersonList=this.accountPersonList
                }
            },
            changeFocusPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this.accountPersons.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this. selectFocusPersonList=selectPerson

                }
                else
                {
                    this. selectFocusPersonList=this.accountPersons
                }
            },
             //下拉加载客户
            loadMoreClient(){
                this.pageSize+=100
                this.getClient()
            },

            //获取搜索公司的下拉值
          /*  changeSelectCompany(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. company.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectCompanyList=selectCompany

                }
                else
                {
                    this.selectCompanyList=this.company.list
                }

            },*/
            loadMore(){
                this.pageSize+=100
                this.getClientCompany()
            },
            clientEmailCheck(){
                const reg= /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if(this.clientMail!=='')
                {
                    if(!reg.test(this.clientMail))
                        this.$message('请输入有效的邮箱')
                }
            },
            clientPhoneCheck(){
                const phone=/^[1][3,4,5,7,8][0-9]{9}$/
                if(this.clientTel!=='')
                {
                    if(!phone.test(this.clientTel))
                        this.$message('请输入有效的电话号码')
                }
            },
            emaiBblurClick(){

                const reg= /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if(this.contactPersonMail!=='')
                {
                    if(!reg.test(this.contactPersonMail))
                        this.$message('请输入有效的邮箱')
                }

            },
            phoneBlurClick(){
                const phone=/^[1][3,4,5,7,8][0-9]{9}$/
                if(this.contactPersonTel!=='')
                {
                    if(!phone.test(this.contactPersonTel))
                        this.$message('请输入有效的电话号码')
                }

            },

            //搜索公司
            inputSelectCompany(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. company.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectCompanyList=selectCompany

                }
                else
                {
                    this.selectCompanyList=this.company.list
                }
            },
            inputSelectClientGroup(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectClientGroupList=selectCompany

                }
                else
                {
                    this.selectClientGroupList=this.accountGroup.list
                }
            },
            inputSelectClientPerson(value){

                if(value!=='')
                {
                    let selectCompany=[]
                    this. accountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectClientPersonList=selectCompany

                }
                else
                {
                    this.selectClientPersonList=this.accountPerson.list
                }
            },
            inputSelectCompanyGroup(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectCompanyGroupList=selectCompany

                }
                else
                {
                    this.selectCompanyGroupList=this.accountGroup.list
                }
            },
            inputSelectCompanyPerson(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. accountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectCompanyPersonList=selectCompany

                }
                else
                {
                    this.selectCompanyPersonList=this.accountPerson.list
                }
            },
            ueditorFocus(){
                this.ueditor=' '
            },
            mouseOrderStatus1(){
                this.showaaaa=1
                this.getNextStatus()
            },
            mouseOrderStatus2(){

                this.showPriority=1

            },
            mouseOrderStatus3(){

                this.showClient=1
            },
            mouseOrderStatus4(){
                this.orderTackerClick=false
                this.showGroup=1
            },
            mouseOrderStatus5(){
                this.showPerson=1
            },
            mouseOrderStatus6(){
                this.showFocusPerson=1
            },
            outClick(){
                if( this.selectShow===1)
                {
                    this.showaaaa=1
                }
                else if( this.selectShow===0)
                {
                    this.showaaaa=0
                }
                if(this.priorityShow===1)
                {
                    this.showPriority=1
                }
                else if(this.priorityShow===0)
                {
                    this.showPriority=0
                }
                if(this.clientShow===1)
                {
                    this.showClient=1
                }
                else if(this.clientShow===0)
                {
                    this.showClient=0
                }
                if(this.groupShow===1)
                {
                    this.showGroup=1
                }
                else if(this.groupShow===0)
                {
                    this.showGroup=0
                }
                if(this.personShow===1)
                {
                    this.showPerson=1
                }
                else if(this.personShow===0)
                {
                    this.showPerson=0
                }
                if(this.focusPersonShow===1)
                {
                    this.showFocusPerson=1
                }
                else if(this.focusPersonShow===0)
                {
                    this.showFocusPerson=0
                }
            },
            visibleChange(value){
                if(value===true)
                    this.selectShow=1
                if(value===false)
                    this.selectShow=0
            },
            visibleChange2(value){
                if(value===true)
                    this.priorityShow=1
                if(value===false)
                    this.priorityShow=0
            },
            visibleChange3(value){
                if(value===true)
                    this.clientShow=1
                if(value===false)
                    this.clientShow=0
            },
            visibleChange4(value){
                if(value===true)
                    this.groupShow=1
                if(value===false)
                    this.groupShow=0
            },
            visibleChange5(value){
                if(value===true)
                    this.personShow=1
                if(value===false)
                    this.personShow=0
            },
            visibleChange6(value){
                if(value===true)
                    this.focusPersonShow=1
                if(value===false)
                    this.focusPersonShow=0
            },
        },

    }
</script>

<style  lang="less">
@import "../../../assets/less/workorder/editworkorder/editworkorder";

.el-radio{
    margin-right: 0;
}
    .el-checkbox{
        margin-right: 0;
    }
     .v-modal{
        z-index: 1099!important;
    }
    div#edui_fixedlayer.edui-default{
        z-index: 2000!important;
    }
    .el-dialog__wrapper{
      z-index: 2000!important;
    }
</style>